import type { Routes } from '@angular/router';
import { page404ComponentRoutes, pageNotFoundComponentRoutes } from '../pages/page-not-found/routes';
import { legalsComponentRoutes } from '../pages/legals/routes';
import { searchResultPageComponentRoutes } from '../pages/search-results-page/routes';
import { productComponentRoutes } from '../pages/product/routes';
import { homeComponentRoutes } from '../pages/home/routes';
import { maintenancePageRoutes } from '../layout/maintenance/routes';
import { PageComponentRoutes } from '../pages/page/routes';
import { RecommendedBrushRoutes } from '../pages/recommended-brush/routes';
import { contentfulAdminRoutes } from '../pages/contentful/routes';

export const appRoutes: Routes[] = [
  homeComponentRoutes,
  productComponentRoutes,
  contentfulAdminRoutes,
  searchResultPageComponentRoutes,
  legalsComponentRoutes,
  RecommendedBrushRoutes,
  page404ComponentRoutes,
  PageComponentRoutes,
  maintenancePageRoutes,
  pageNotFoundComponentRoutes,
];
